import Hero from "../components/sections/Hero";
import About from "../components/sections/About";
import ClientLogos from "../components/sections/ClientLogos";
import Services from "../components/sections/Services";
import Features from "../components/sections/Features";
import Stats from "../components/sections/Stats";
import Testimonials from "../components/sections/Testimonials";
import Contact from "../components/sections/Contact";
import OurTeam from "../components/sections/OurTeam";
import FAQ from "../components/sections/FAQ";
import MediaSection from "../components/sections/MediaSection";
import CtaBanner from "../components/sections/CtaBanner";

export default function Home() {
  return (
    <>
      <Hero />
      <ClientLogos />
      <About />
      <Services />
      <Features />
      <Stats />
      <OurTeam />
      <Testimonials />
      <MediaSection />
      <FAQ />
      <Contact />
      <CtaBanner />
    </>
  );
}
